// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlobalDayDetail_placeholder__hBJ17 {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  padding: 30px;
  color: #acacac;
  font-size: 14px;
  text-align: center;
}

.GlobalDayDetail_panel__6Wx8Y {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.GlobalDayDetail_header__HqgTP {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #f4f5f7;
  padding-bottom: 5px;
}

.GlobalDayDetail_title__-iFCt {
  margin: 0;
  font-family: monospace;
  font-size: 18px;
  font-weight: 600;
  color: var(--primary-color);
}

.GlobalDayDetail_subtitle__6QgCw {
  margin: 2px 0 0;
  font-size: 14px;
  color: #acacac;
}

.GlobalDayDetail_closeBtn__pNbf3 {
  background: none;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  color: #838383;
}
.GlobalDayDetail_closeBtn__pNbf3:hover {
  opacity: 0.7;
}

.GlobalDayDetail_successCard__0j78q {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  background: rgba(87, 188, 143, 0.08);
  border: 1px solid rgba(87, 188, 143, 0.25);
  border-radius: 3px;
}

.GlobalDayDetail_successPct__TaBxG {
  font-size: 32px;
  font-weight: 700;
  color: #2d8758;
  line-height: 1;
}

.GlobalDayDetail_successLabel__BkDB1 {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #838383;
}

.GlobalDayDetail_successRatio__uPhIH {
  margin-top: 2px;
  font-size: 14px;
  font-family: monospace;
  color: #acacac;
}

.GlobalDayDetail_list__fJggG {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.GlobalDayDetail_row__0MJw\\+ {
  display: grid;
  grid-template-columns: 12px 1fr 90px 36px 50px;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #838383;
}

.GlobalDayDetail_dot__saoE7 {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.GlobalDayDetail_label__42L24 {
  font-weight: 500;
}

.GlobalDayDetail_bar__pQS54 {
  position: relative;
  height: 6px;
  background: #f4f5f7;
  border-radius: 3px;
  overflow: hidden;
}

.GlobalDayDetail_barFill__J32vY {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 3px;
}

.GlobalDayDetail_count__w81xz {
  text-align: right;
  font-family: monospace;
  font-weight: 600;
}

.GlobalDayDetail_pct__14\\+Ek {
  text-align: right;
  font-family: monospace;
  color: #acacac;
}

.GlobalDayDetail_processed__b9Mg- {
  background: var(--accent-color);
}

.GlobalDayDetail_processing__D9qOL {
  background: #3b7fd4;
}

.GlobalDayDetail_pending__IZB6H {
  background: #00bcd4;
}

.GlobalDayDetail_waiting_archive__164Bh {
  background: #64b5f6;
}

.GlobalDayDetail_duplicate__ZBiBN {
  background: #8e6acb;
}

.GlobalDayDetail_upload_failed__kVXd8 {
  background: #efa12c;
}

.GlobalDayDetail_failed__Tlncq {
  background: #df6767;
}

.GlobalDayDetail_no_data__Y5h31 {
  background: #7a7a7a;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/GlobalDayDetail/GlobalDayDetail.module.scss","webpack://./src/_common/scss/_variables.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,aCDW;EDEX,cEDS;EFET,eCMe;EDLf,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SCPS;ADKX;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,gCAAA;EACA,mBChBS;ADcX;;AAKA;EACE,SAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BEjCQ;AF+BV;;AAKA;EACE,eAAA;EACA,eCtBe;EDuBf,cE/BS;AF6BX;;AAKA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cEvCS;AFqCX;AAIE;EAAU,YAAA;AADZ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aCpDU;EDqDV,oCAAA;EACA,0CAAA;EACA,kBC1Dc;ADyDhB;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cEnES;AFkEX;;AAIA;EACE,eAAA;EACA,eCjEe;EDkEf,sBAAA;EACA,cE3ES;AF0EX;;AAIA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,aAAA;EACA,8CAAA;EACA,mBAAA;EACA,QC1FS;ED2FT,eAAA;EACA,cE5FS;AF2FX;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,mBE/GS;EFgHT,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;AADF;;AAIA;EACE,iBAAA;EACA,sBAAA;EACA,gBAAA;AADF;;AAIA;EACE,iBAAA;EACA,sBAAA;EACA,cEnIS;AFkIX;;AAIA;EAAmB,+BE5IV;AF4IT;;AACA;EAAmB,mBAAA;AAGnB;;AAFA;EAAmB,mBAAA;AAMnB;;AALA;EAAmB,mBAAA;AASnB;;AARA;EAAmB,mBAAA;AAYnB;;AAXA;EAAmB,mBAAA;AAenB;;AAdA;EAAmB,mBEvIX;AFyJR;;AAjBA;EAAmB,mBAAA;AAqBnB","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 220px;\n  padding: $padding-xl;\n  color: $grey-300;\n  font-size: $base-font-size;\n  text-align: center;\n}\n\n.panel {\n  display: flex;\n  flex-direction: column;\n  gap: $margin-m;\n}\n\n.header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  border-bottom: 1px solid $grey-100;\n  padding-bottom: $margin-s;\n}\n\n.title {\n  margin: 0;\n  font-family: monospace;\n  font-size: 18px;\n  font-weight: 600;\n  color: $primary;\n}\n\n.subtitle {\n  margin: 2px 0 0;\n  font-size: $base-font-size;\n  color: $grey-300;\n}\n\n.closeBtn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n  color: $grey-400;\n\n  &:hover { opacity: 0.7; }\n}\n\n.successCard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: $padding-m;\n  background: rgba(87, 188, 143, 0.08);\n  border: 1px solid rgba(87, 188, 143, 0.25);\n  border-radius: $border-radius;\n}\n\n.successPct {\n  font-size: 32px;\n  font-weight: 700;\n  color: #2d8758;\n  line-height: 1;\n}\n\n.successLabel {\n  margin-top: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $grey-400;\n}\n\n.successRatio {\n  margin-top: 2px;\n  font-size: $base-font-size;\n  font-family: monospace;\n  color: $grey-300;\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.row {\n  display: grid;\n  grid-template-columns: 12px 1fr 90px 36px 50px;\n  align-items: center;\n  gap: $margin-s;\n  font-size: 12px;\n  color: $grey-400;\n}\n\n.dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.label {\n  font-weight: 500;\n}\n\n.bar {\n  position: relative;\n  height: 6px;\n  background: $grey-100;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.barFill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  border-radius: 3px;\n}\n\n.count {\n  text-align: right;\n  font-family: monospace;\n  font-weight: 600;\n}\n\n.pct {\n  text-align: right;\n  font-family: monospace;\n  color: $grey-300;\n}\n\n.processed       { background: $accent; }\n.processing      { background: #3b7fd4; }\n.pending         { background: #00bcd4; }\n.waiting_archive { background: #64b5f6; }\n.duplicate       { background: #8e6acb; }\n.upload_failed   { background: #efa12c; }\n.failed          { background: $error; }\n.no_data         { background: #7a7a7a; }\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"placeholder": `GlobalDayDetail_placeholder__hBJ17`,
	"panel": `GlobalDayDetail_panel__6Wx8Y`,
	"header": `GlobalDayDetail_header__HqgTP`,
	"title": `GlobalDayDetail_title__-iFCt`,
	"subtitle": `GlobalDayDetail_subtitle__6QgCw`,
	"closeBtn": `GlobalDayDetail_closeBtn__pNbf3`,
	"successCard": `GlobalDayDetail_successCard__0j78q`,
	"successPct": `GlobalDayDetail_successPct__TaBxG`,
	"successLabel": `GlobalDayDetail_successLabel__BkDB1`,
	"successRatio": `GlobalDayDetail_successRatio__uPhIH`,
	"list": `GlobalDayDetail_list__fJggG`,
	"row": `GlobalDayDetail_row__0MJw+`,
	"dot": `GlobalDayDetail_dot__saoE7`,
	"label": `GlobalDayDetail_label__42L24`,
	"bar": `GlobalDayDetail_bar__pQS54`,
	"barFill": `GlobalDayDetail_barFill__J32vY`,
	"count": `GlobalDayDetail_count__w81xz`,
	"pct": `GlobalDayDetail_pct__14+Ek`,
	"processed": `GlobalDayDetail_processed__b9Mg-`,
	"processing": `GlobalDayDetail_processing__D9qOL`,
	"pending": `GlobalDayDetail_pending__IZB6H`,
	"waiting_archive": `GlobalDayDetail_waiting_archive__164Bh`,
	"duplicate": `GlobalDayDetail_duplicate__ZBiBN`,
	"upload_failed": `GlobalDayDetail_upload_failed__kVXd8`,
	"failed": `GlobalDayDetail_failed__Tlncq`,
	"no_data": `GlobalDayDetail_no_data__Y5h31`
};
export default ___CSS_LOADER_EXPORT___;
